import { createIcon } from './icon-utils';

export const DoubleCheckIcon = createIcon({
  path: 'M5.0251 13.4992L0.787598 9.26172L1.85635 8.21172L5.04385 11.3992L6.09385 12.4492L5.0251 13.4992ZM9.2626 13.4992L5.0251 9.26172L6.0751 8.19297L9.2626 11.3805L16.1626 4.48047L17.2126 5.54922L9.2626 13.4992ZM9.2626 9.26172L8.19385 8.21172L11.9063 4.49922L12.9751 5.54922L9.2626 9.26172Z',
  style: { height: 18, width: 18 },
  viewBox: '0 0 18 18',
});
